import { render, staticRenderFns } from "./PM.vue?vue&type=template&id=3435518e"
import script from "./PM.vue?vue&type=script&lang=js"
export * from "./PM.vue?vue&type=script&lang=js"
import style0 from "./PM.vue?vue&type=style&index=0&id=3435518e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports